import styled, { css } from 'styled-components/macro'

import { Table } from '@loadsmart/loadsmart-ui'
import { getToken } from '@loadsmart/loadsmart-ui/dist/theming'

function errorRowStyle({ $hasError }: { $hasError: boolean }) {
  return (
    $hasError &&
    css`
      background-color: ${getToken('color-danger-light')};
    `
  )
}

export const StyledRow = styled(Table.ExpandableRow)<{ $hasError: boolean }>`
  ${errorRowStyle};
`
